import React, { useEffect, useRef } from "react";

// HOOKS
import useMediaQuery from "../hooks/useMediaQuery";

// COMPONENTS
import MusicButtonAudioSpectrum from "./MusicButtonAudioSpectrum";
import Button from "./Button";
import SocialMedia from "./SocialMedia";

// STATE
import { useRecoilState } from "recoil";
import { languageState, musicInFooter, musicInPlayer } from "../atoms/atom";

// DATA
import audio from "../assets/audio/El_choclo.mp3";

const Footer = () => {
  const audioRef = useRef(null);
  const isAboveSmallScreens = useMediaQuery("(min-width: 768px)");
  const [language, setLanguage] = useRecoilState(languageState);
  const [isMusicInFooter, setIsMusicInFooter] = useRecoilState(musicInFooter);
  const [IsMusicInPlayer, setIsMusicInPlayer] = useRecoilState(musicInPlayer);

  function getCurrentYear() {
    return new Date().getFullYear();
  }

  const changeLanguage = () => {
    setLanguage(language === "PL" ? "EN" : "PL");
  };

  const handlePlayMusicButton = () => {
    setIsMusicInFooter((prev) => !prev);
    setIsMusicInPlayer(false);
  };

  useEffect(() => {
    audioRef.current.load();
    if (isMusicInFooter) {
      audioRef.current.play();
    } else {
      audioRef.current.pause();
    }
  }, [isMusicInFooter]);

  return (
    <footer>
      <div className="flex justify-between items-start md:items-center">
        <div className="max-h-20 md:max-h-12 flex flex-col">
          <SocialMedia />
          {isAboveSmallScreens ? null : (
            <p className="text-[10px] font-light mt-5 mb-0">
              © {getCurrentYear()} Colours of Tango
            </p>
          )}
        </div>

        <div className="flex gap-5">
          <Button
            content={language}
            handleClick={changeLanguage}
            styles={"text-xs"}
          />
          <audio ref={audioRef} id="audio-element" src={audio} />

          {/* MUSIC BUTTON */}
          <Button
            handleClick={handlePlayMusicButton}
            content={
              <MusicButtonAudioSpectrum
                type="footer"
                isMusicInFooter={isMusicInFooter}
              />
            }
            styles={"text-xs"}
          />
        </div>
      </div>
      {isAboveSmallScreens ? (
        <p className="text-[10px] font-light mt-5 mb-0">
          © {getCurrentYear()} Colours of Tango
        </p>
      ) : null}
    </footer>
  );
};

export default Footer;
